<template>
  <el-dialog :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
             :close-on-click-modal="false"
             title="完善数据">
    <div class='dialogBody'>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>现有资产规模：</span>
        </el-col>
        <el-col :span='18'>
          <el-input v-model='alreadyScaleSaving' size='small'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>税前工资收入：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="preTaxCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='preTaxIncome' size='small' @blur='handleIncomeBlur'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>其他收入：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="preTaxCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='otherIncome' size='small'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>完善支出数据：</span>
        </el-col>
        <el-col :span='18'>
          <el-checkbox v-model='hasExpenses'></el-checkbox>
        </el-col>
      </el-row>
      <el-row :gutter="20" style='margin: 20px 0' v-show='hasExpenses'>
        <el-col :span='6' class='spanCol'>
          <span>预估支出：</span>
        </el-col>
        <el-col :span='4'>
          <el-select v-model="expensesCycle" size='small'>
            <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span='14'>
          <el-input v-model='expenses' size='small'></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
        <el-col :span='6' class='spanCol'>
          <span>完善社保数据：</span>
        </el-col>
        <el-col :span='18'>
          <el-checkbox v-model='hasPublicPension'></el-checkbox>
        </el-col>
      </el-row>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0' v-show='hasPublicPension'>
        <el-col :span='6' class='spanCol'>
          <span>城市：</span>
        </el-col>
        <el-col :span='18'>
          <el-select v-model="city" placeholder="请选择" size='small' style='width: 200px'>
            <el-option v-for="item in cities" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0' v-show='hasPublicPension'>
        <el-col :span='6' class='spanCol'>
          <span>实际缴费年限：</span>
        </el-col>
        <el-col :span='18'>
          <el-input-number v-model="currentSocialSecurityPaidYears" :min="0" :max="50" size='small' style='width: 200px'></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0' v-show='hasPublicPension'>
        <el-col :span='6' class='spanCol'>
          <span>当前个人账户余额：</span>
          <el-tooltip effect="dark" :content="currentAccountBalanceP1Tooltip" placement="top-start">
            <i class="el-icon-warning ml-5"></i>
          </el-tooltip>
        </el-col>
        <el-col :span='18'>
          <el-input v-model="currentAccountBalanceP1" size='small' style='width: 200px' @blur='handleBalanceBlur'></el-input>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CompleteDataDialog',
  props: ['dialogVisible', 'currentAge'],
  computed: {
    token () {
      return this.$store.getters.getToken
    },
  },
  watch: {
    dialogVisible (val) {
      this.dialogVisibleValue = val
    },
    currentAge (val) {
      this.currentSocialSecurityPaidYears = val >= 25 ? val - 25 : 0
    }
  },
  mounted() {
    const url = this.$api.SupportCities
    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
    this.$http.post(url, {}, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
      this.cities = res.data
    })
  },
  data() {
    return {
      hasExpenses: false,
      hasPublicPension: false,
      balanceChangeFlag: false,
      dialogVisibleValue: false,
      alreadyScaleSaving: 0,
      preTaxIncome: 0,
      preTaxCycle: 'month',
      otherIncome: 0,
      otherCycle: 'month',
      cycleOptions: [{label: '月度', value: 'month'}, {label: '年度', value: 'year'}],
      expensesIndex: 0,
      expenses: 0,
      expensesCycle: 'month',
      getToken: '',

      privatePensionIndex: 4,
      city: '北京',
      cities: [],
      currentSocialSecurityPaidYears: 0,
      currentAccountBalanceP1: 0,
      currentAccountBalanceP1Tooltip: '可在支付宝查询社保养老金获得该信息',
    }
  },
  methods: {
    handleIncomeBlur () {
      console.log('111')
      if (!this.balanceChangeFlag) {
        var monthIncome = this.preTaxCycle === 'month' ? this.preTaxIncome : this.preTaxIncome / 12
        this.currentAccountBalanceP1 = this.currentSocialSecurityPaidYears * monthIncome * 12 *0.08
      }
    },
    handleBalanceBlur () {
      this.balanceChangeFlag = true
    },
    confirm () {
      const data = {
        incomeData: {
        "EXISTING_SAVINGS_AMOUNT": this.alreadyScaleSaving,
        "INCOME_SUBJECT_TO_TAXATION": this.preTaxCycle === 'month' ? this.preTaxIncome : this.preTaxIncome / 12,
        "OTHER_INCOMES": this.otherCycle === 'month' ? this.otherIncome : this.otherIncome / 12
      },
        hasExpenses: this.hasExpenses,
        expensesData: this.hasExpenses ? {
          "ESTIMATED_SPENDING": this.expensesCycle === 'month' ? this.expenses : this.expenses / 12
        } : {},
        hasPublicPension: this.hasPublicPension,
        publicPensionData: this.hasPublicPension ? {
          "CITY": this.city,
          "CURRENT_SOCIAL_SECURITY_PAID_YEARS": this.currentSocialSecurityPaidYears,
          "CURRENT_ACCOUNT_BALANCE_P1": this.currentAccountBalanceP1,
        } : {}
      }
      this.$emit('dialogConfirm', data)
      this.closeDialog()
    },
    closeDialog () {
      this.dialogVisibleValue = false
      this.$emit('dialogVisibleChange', this.dialogVisibleValue)
    },
  }
}
</script>

<style scoped>
.dialogBody {
  max-height: 460px;
  overflow-y: auto;
  font-size: 18px;
}
.spanCol {
  /*text-align: right;*/
}
</style>



// WEBPACK FOOTER //
// src/components/options/CompleteDataDialog.vue